import "./carrusel_automatico_marcas.css";
import coizav from "../../assets/logos_marcas/coizav.png";
import ferreyros from "../../assets/logos_marcas/ferreyros.png";
import honda from "../../assets/logos_marcas/honda.png";
import izipay from "../../assets/logos_marcas/izipay.png";
import molycop from "../../assets/logos_marcas/Molycop.png";
import tinka from "../../assets/logos_marcas/tinka.png";
import opella from "../../assets/logos_marcas/Opella.png";
import industriasSanMiguel from "../../assets/logos_marcas/Industrias_San_Miguel.png";
import lupaAutoparts from "../../assets/logos_marcas/lupa_autoparts.png"
import LogoBackus from "../../assets/logos_marcas/Backus_logo.png"
import Tecsur from "../../assets/logos_marcas/tecsur_blanco.png"

const marcas = [LogoBackus, Tecsur, coizav, ferreyros, honda, izipay, molycop, lupaAutoparts, tinka, opella, industriasSanMiguel];
export default function MarcasCarousel() {
  return (
    <div className="marcas-wrapper">
      <div className="marcas-track">
        {marcas.concat(marcas).map((logo, idx) => (
          <div className="marca" key={idx}>
            <img src={logo} alt={`Marca ${idx}`} />
          </div>
        ))}
        {/* Duplicamos otra vez para asegurar fluidez */}
        {marcas.concat(marcas).map((logo, idx) => (
          <div className="marca" key={`dup-${idx}`}>
            <img src={logo} alt={`Marca ${idx}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

